// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.noOrLowCostTableDiv {
    width: 100%;
}


.offerManagementSearchDiv {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 24px 0px;
    width: 100%
}


.offerInputFieldWidth {
    width: 70%
}`, "",{"version":3,"sources":["webpack://./src/components/pages/offerManagementT/noOrLowCostEmi/noOrLowCostEmi.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;;AAGA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB;AACJ;;;AAGA;IACI;AACJ","sourcesContent":[".noOrLowCostTableDiv {\n    width: 100%;\n}\n\n\n.offerManagementSearchDiv {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin: 24px 0px;\n    width: 100%\n}\n\n\n.offerInputFieldWidth {\n    width: 70%\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
